module.exports = __webpack_public_path__ + "img/logos.d8579181.png";